import React, { useEffect, useState } from "react";
import "./ProductShowCase.css";
import { Link } from "react-router-dom";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { app } from "../firebase";

const ProductShowcase = () => {
  const [products, setProducts] = useState([]);
  const db = getFirestore(app);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const productsCollection = collection(db, "products");
        const productsSnapshot = await getDocs(productsCollection);

        const productsList = await Promise.all(
          productsSnapshot.docs.map(async (docSnapshot) => {
            const productData = docSnapshot.data();

            // Fetch prices subcollection
            const pricesSnapshot = await getDocs(
              collection(db, "products", docSnapshot.id, "prices")
            );
            let price = "$0";
            pricesSnapshot.forEach((priceDoc) => {
              const priceData = priceDoc.data();
              if (priceData.active) {
                price = `$${(priceData.unit_amount / 100).toFixed(2)}`;
              }
            });

            return {
              id: docSnapshot.id,
              name: productData.name,
              images: productData.images,
              price,
            };
          })
        );

        setProducts(productsList);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, [db]);

  return (
    <section id="products" className="ProductShowcase">
      <div className="ProductShowCase_Content">
      <h2>Best sellers</h2>
      <div className="ProductShowcase_Grid">
        {products.map((item) => (
          <Link
            key={item.id}
            to={`/product/${item.id}`}
            className="ProductShowcase_Card"
          >
            <img
              src={item.images?.[0] || "/images/default.png"}
              alt={item.name}
            />
            <h3>{item.name}</h3>
            <p>{item.price}</p>
          </Link>
        ))}
        </div>
      </div>
    </section>
  );
};

export default ProductShowcase;
